import axios from "axios";
import * as types from "./types";

const actions = {
  [types.FINISH_MY_DESIGN](context, { locale, recipeJSON, changedSwatches }) {
    const requestUrl = this.state.endPoints.customizer.finishMyDesign;
    const data = {
      recipe: recipeJSON,
      locale,
      changedSwatches
    };
    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: "POST",
        headers: { "content-type": "application/json" },
        data: JSON.stringify(data)
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  }
};

export default actions;